// Slider

$(function() {
  'use strict';

  $('.js-slider-testimonials').slick({
    arrows: true,
    dots: true,
    dotsClass: 'c-slider__dots',
    fade: true,
    infinite: false,
    prevArrow: '.js-slider-testimonials-prev',
    nextArrow: '.js-slider-testimonials-next',
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $('.js-slider-services').slick({
    arrows: true,
    dots: false,
    infinite: false,
    prevArrow: '.js-slider-services-prev',
    nextArrow: '.js-slider-services-next',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

});
